<template>
    <div>
        <!-- :ref="(el) => { markers[item.IdInstalacion] = el as unknown as typeof LMarker; }" -->
        <div id="mapContainer">
            <l-map :zoom="zoomMapa" :center="[latitudMadrid, longitudMadrid]" :use-global-leaflet="false" ref="lmap"
                :options="{ attributionControl: false, minZoom: 4 }">
                <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base"
                    name="OpenStreetMap">
                </l-tile-layer>
                <l-marker v-for="item in instalacionesConOscilos" :key="item.IdInstalacion"
                    :lat-lng="[item.LatitudInstalacion, item.LongitudInstalacion]"
                    :ref="(el) => storeRefMarkers(el as unknown as typeof LMarker, item.IdInstalacion)"
                    :icon="getMarkerIcon(item.IdPeorEstado as OsciloEstadoTipoEnum)">
                    <l-popup :options="{ minWidth: 300 }">
                        <div :class="['estado-color', `estado-${item.IdPeorEstado}`]"></div>
                        <div class="datos-generales-instalacion">
                            <h3 class="nombre-instalacion">{{ item.NombreCompletoInstalacion }}</h3>
                        </div>
                        <CajitaOscilo :osciloProp="oscilo" :vistaMapaProp="true" :vistaCuadriculaProp="false"
                            :vistaDetalleProp="false" v-for="oscilo in item.Oscilos" :key="oscilo.Id">
                        </CajitaOscilo>
                    </l-popup>
                </l-marker>
            </l-map>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import CajitaOscilo from './CajitaOscilo.vue';
import type { OsciloDetalleModel } from "@/.shared/.api";
import { OsciloEstadoTipoEnum } from '@/model/oscilo';
import { groupBy, map, maxBy, type Dictionary } from 'lodash';
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';
import { getMarkerIcon } from '@/.shared/helpers/map-helper';
import type { LatLngExpression } from 'leaflet';

const zoomMapa = 6;
const latitudMadrid = 40.41694;
const longitudMadrid = -3.70361;
const centroMapa: LatLngExpression = [latitudMadrid, longitudMadrid];

const lmap = ref<typeof LMap>();
const markers = ref<Record<number, typeof LMarker>>({});
const props = defineProps<{ oscilosProp: OsciloDetalleModel[], idInstalacionSeleccionadaProp?: number }>();
const instalacionesConOscilos = computed(() => {
    // let oscilos = props.oscilosProp;
    // let instalacionesConOscilos: Dictionary<OsciloDetalleModel[]> = groupBy(oscilos, (x) => x.IdInstalacion);
    // return map(instalacionesConOscilos, (oscilos, key) => { // map = .Select + .ToArray de .NET
    //     let oscilo = oscilos[0];
    //     return {
    //         IdInstalacion: parseInt(key),
    //         NombreCompletoInstalacion: oscilo.NombreCompletoInstalacion,
    //         IdPeorEstado: maxBy(oscilos, x => x.IdOsciloEstadoTipo)?.IdOsciloEstadoTipo,
    //         LatitudInstalacion: oscilo.LatitudInstalacion,
    //         LongitudInstalacion: oscilo.LongitudInstalacion,
    //         Oscilos: oscilos
    //     }
    // });

    let oscilos = props.oscilosProp;
    return oscilos
        .groupBy(x => x.IdInstalacion)
        .select(x => {
            let oscilo = x.first();
            return {
                IdInstalacion: x.key,
                NombreCompletoInstalacion: oscilo.NombreCompletoInstalacion,
                IdPeorEstado: x.max(y => y.IdOsciloEstadoTipo),
                LatitudInstalacion: oscilo.LatitudInstalacion,
                LongitudInstalacion: oscilo.LongitudInstalacion,
                Oscilos: x.toArray()
            }
        }).toArray();

});

watch(() => (props.idInstalacionSeleccionadaProp), (nuevaIdInstalacionSeleccionada?: number /*, viejaIdInstalacionSeleccionada?: number*/) => {
    if (nuevaIdInstalacionSeleccionada != null) {
        const marker = markers.value[nuevaIdInstalacionSeleccionada]!;
        marker.leafletObject.openPopup();
    } else {
        centrarMapa();
    }
}, { immediate: true });

function centerMap(): void {
    centrarMapa();
}

function storeRefMarkers(el: typeof LMarker | undefined, key: number): void {
    if (el)
        markers.value[key] = el;
    else
        delete markers.value[key]; // cleanup when element is removed
};

function centrarMapa() {
    const map = lmap.value?.leafletObject!;
    if (map != null) {
        map.closePopup();
        // map.setView([40.41694, -3.70361]);
        // map.setZoom(6);
        map.flyTo(centroMapa, zoomMapa);
    }
}

defineExpose({
    centerMap
});
</script>



<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

#mapContainer {
    width: 100%;
    height: calc(100vh - 165px);
    border-radius: var(--border-radius-xl, 16px);
    overflow: hidden;
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);
}

.leaflet-container {
    font-family: var(--font-family-headings, "IberPangea Text");

}

.datos-generales-instalacion {
    margin-bottom: var(--spacing-xs);
}

.nombre-instalacion {
    font-size: var(--font-size-body-lg);
    color: $base-accent;
    font-weight: 600;
    line-height: var(--line-height-body-md);
    margin-top: var(--spacing-lg);
}


.estado-color[class^="estado-"] {
    width: 100%;
    height: var(--ui-oscilo-card-estado-color-height);
    position: absolute;
    top: 0;
    left: 0;
    border-radius: var(--spacing-sm) var(--spacing-sm) 0 0;
}

//No inicializado
.estado-color.estado-0 {
    background: var(--background-ui-estado-no-inicializado);
}

//Funcionando
.estado-color.estado-1 {
    background: var(--background-ui-estado-funcionando);
}

//Stand by
.estado-color.estado-2 {
    background: var(--background-ui-estado-standby);
}

//Suceso nuevo
.estado-color.estado-3 {
    background: var(--background-ui-estado-suceso-nuevo);
}

//Suceso reciente
.estado-color.estado-4 {
    background: var(--background-ui-estado-suceso-reciente);
}

//Suceso antiguo
.estado-color.estado-5 {
    background: var(--background-ui-estado-suceso-antiguo);
}

//Error
.estado-color.estado-6 {
    background: var(--background-ui-estado-error);
}
</style>